webpackJsonp([213720915766396],{

/***/ "./src/data/projects.js":
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var projects = [{
	  title: 'micro-spotify',
	  description: 'A microservice to simplify authorizing with Spotify\'s API via the Oauth2 Authorization code flow.',
	  url: 'https://github.com/ntaylor89/micro-spotify'
	}, {
	  title: 'spotable',
	  description: 'A react-app that helps users build better Spotify playlists using track data from the API',
	  url: 'https://github.com/ntaylor89/spotable'
	}];
	
	exports.default = projects;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/layouts/slat.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Slat;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Slat(props) {
	  if (!props.title) return null;
	
	  var linkStyle = 'black link hover-blue';
	  var link = props.static ? _react2.default.createElement(
	    'a',
	    { href: props.url, className: linkStyle },
	    props.title
	  ) : _react2.default.createElement(
	    _gatsbyLink2.default,
	    { to: props.url, className: linkStyle },
	    props.title
	  );
	
	  return _react2.default.createElement(
	    'article',
	    { className: 'pv3' },
	    _react2.default.createElement(
	      'div',
	      { className: 'flex flex-column flex-row-ns' },
	      _react2.default.createElement(
	        'div',
	        { className: 'w-100 pr3-ns order-2 order-1-ns' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'f3 mv0 lh-title' },
	          link
	        ),
	        props.subTitle && _react2.default.createElement(
	          'span',
	          { className: 'f6 mid-gray' },
	          props.subTitle
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'f5 f4-l lh-copy' },
	          props.summary
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/ntaylor/Workspace/nate-site/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/ntaylor/Workspace/nate-site/node_modules/babel-plugin-lodash/lib/index.js\",\"/Users/ntaylor/Workspace/nate-site/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/ntaylor/Workspace/nate-site/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[\"/Users/ntaylor/Workspace/nate-site/node_modules/babel-preset-es2015/lib/index.js\",[\"/Users/ntaylor/Workspace/nate-site/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/ntaylor/Workspace/nate-site/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/ntaylor/Workspace/nate-site/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/projects.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = ProjectIndex;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _projects = __webpack_require__("./src/data/projects.js");
	
	var _projects2 = _interopRequireDefault(_projects);
	
	var _slat = __webpack_require__("./src/layouts/slat.js");
	
	var _slat2 = _interopRequireDefault(_slat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ProjectIndex(props) {
	  return _react2.default.createElement(
	    'section',
	    null,
	    _projects2.default.map(function (project) {
	      return _react2.default.createElement(_slat2.default, {
	        title: project.title,
	        summary: project.description,
	        url: project.url,
	        'static': true,
	        subTitle: project.url
	      });
	    })
	  );
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-js-f94353918e1ef635ebd0.js